export default "__VITE_ASSET__Blmgpcop__"